import { render, staticRenderFns } from "./CautionModalCaregiver.vue?vue&type=template&id=938e7abe&scoped=true&lang=pug"
import script from "./CautionModalCaregiver.vue?vue&type=script&lang=js"
export * from "./CautionModalCaregiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938e7abe",
  null
  
)

export default component.exports